<div class="h-full w-full">
    <div class="h-1" *ngIf="isRouteLoading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <div class="w-full p-4 flex justify-between items-center h-24">
        <div class="grid grid-cols-3 gap-4 items-center">
            <!-- search route -->
            <div class="border border-gray-300 bg-white h-12 w-64 flex items-center rounded-md shadow-sm px-3 py-3 text-base space-x-2">
                <input type="text"
                    class="mt-1 mb-1 block w-full"
                    placeholder="{{'search.route.placeholder' | translate}}" [(ngModel)]="searchText"
                    (keyup.enter)="triggerSearch($event)" (blur)="onSearchBlur()">
                <button *ngIf="searchText?.length" aria-label="Clear" class="mt-1.5" (click)="clearSearch()"> <i
                        class="ti ti-x text-xl"></i> 
                </button>
            </div>
            <div class="mr-4">
                <input [matDatepicker]="picker" type="text" name="filterDate" id="filterDate" readonly
                    [datePickerFormat]="utilityService?.dateFormat"
                    class="mt-1 mb-1 block w-full rounded-md border border-gray-300 bg-white shadow-sm px-3 py-3 text-base cursor-pointer"
                    placeholder="{{'text.choose_date.header' | translate}}" [(ngModel)]="date" (click)="picker.open()"
                    (dateChange)="onDateChange($event)">
                <mat-datepicker #picker [dateClass]="dateClass"></mat-datepicker>
            </div>
            <div class="flex items-center border-gray-300 rounded-md border w-fit p-3 primary-font font-normal">
                <div class="flex items-center mr-2 cursor-pointer">
                    <em class="ti icon-size-5 mt-1" matTooltipPosition="above"
                        (click)="changeSortType()"
                        matTooltip="{{(sortParams.sortType === 'ASC' ? 'dataPicker.sort.ascending' : 'dataPicker.sort.descending') | translate}}"
                        [ngClass]="{'ti-sort-ascending': sortParams.sortType === 'ASC', 'ti-sort-descending': sortParams.sortType === 'DESC'}"></em>
                </div>
                <div class="flex space-x-1 items-center ml-auto cursor-pointer"
                    [matMenuTriggerFor]="routeSortMenu">
                    <div class="text-base">{{sortParams.sortByDisplayName | translate}}</div>
                    <em class="ti ti-chevron-down icon-size-5 mt-1"></em>
                </div>
            </div>
            <mat-menu #routeSortMenu="matMenu">
                <button mat-menu-item class="text-base h-10 text-gray-700" *ngFor="let item of sortItems"
                    (click)="sortMenuClick(item)" [ngClass]="{ 'active-menu-item': sortParams.sortBy === item.sortKey }">
                    <span class="flex items-center">
                        <span>{{item.displayKey | translate}}</span>
                    </span>
                </button>
            </mat-menu>
        </div>
        <!-- Pagination -->
        <mat-paginator class="data-picker-paginate h-18 min-w-fit" [length]="pagination.totalRecords"
            [pageSize]="pagination.pageSize" [hidePageSize]="true" [pageIndex]="((pagination?.pageIndex || 1 )- 1) || 0"
            (page)="onPageEvent($event)">
        </mat-paginator>
    </div>
    <div class="overflow-y-auto zuper-scrollbar assign-route-height" *ngIf="routes.length">
        <ul role="list" class="divide-y divide-gray-200">
            <li *ngFor="let route of routes;let i=index" [ngClass]="{'bg-gray-100': route?.is_locked}">
                <div class="flex justify-between hover:bg-gray-50">
                    <div class=" group relative flex items-center justify-between py-3 px-5 w-full">
                        <div class="flex items-center">
                            <input id="{{route?.route_name +'_'+ i}}" type="radio" [value]="route?.route_uid"
                                [(ngModel)]="routeSelected" [disabled]="route?.is_locked"
                                class="h-4 w-4 border-gray-300 text-indigo-600"
                                (click)="setSelectedRoute(route)">
                            <span *ngIf="route?.is_locked" title="{{utilityService.getLocaleValue('route.locked')}}"><i
                                    class="ti ti-lock text-2xl ml-2 text-gray-500"></i></span>
                            <label for="{{route?.route_name +'_'+ i}}"
                                class="mt-0.5 block text-base font-medium cursor-pointer"
                                [ngClass]="route?.is_locked? 'ml-1 text-gray-500': 'ml-3 text-gray-700'">{{route?.route_name}}</label>
                        </div>
                        <div class="flex" *ngIf="route?.is_locked" >
                            <button type="button" (click)="unlockRoute(route)"
                                class="px-2 flex items-center py-1 border b-1 border-gray-300 text-black shadow-sm text-base primary-font rounded-md bg-white focus:outline-none btn-small">
                                <img class="h-5 w-5 mr-1 mb-1" src="/assets/images/svgs/lock_open.svg" alt="" loading="lazy">
                                {{'text.unlock_route' | translate}}</button>
                        </div>
                    </div>
                    <div class="p-4">
                        <button *ngIf="!(showDataIndex === i && showData)"
                            class="cursor-pointer hover:bg-gray-100 rounded-full flex justify-center items-center p-1"
                            (click)="expandPanel(i)" matTooltip="{{'expand' | translate}}"
                            matTooltipPosition="above">
                            <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                                data-mat-icon-type="svg" data-mat-icon-name="x"
                                data-mat-icon-namespace="heroicons_outline" svgIcon="tabler:tabler-chevron-down">
                            </mat-icon>
                        </button>
                        <button *ngIf="showDataIndex === i && showData"
                            class="cursor-pointer hover:bg-gray-100 rounded-full flex justify-center items-center p-1"
                            (click)="showData=!showData"
                            matTooltip="{{'collapse' | translate}}"
                            matTooltipPosition="above">
                            <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                                data-mat-icon-type="svg" data-mat-icon-name="x"
                                data-mat-icon-namespace="heroicons_outline" svgIcon="tabler:tabler-chevron-up">
                            </mat-icon>
                        </button>
                    </div>
                </div>
                <div class="p-4 bg-gray-100" *ngIf="showDataIndex === i && showData">
                    <div class="bg-card rounded-md transform transition-transform duration-200">
                        <dl class="grid grid-cols-2">
                            <div class="p-4">
                                <dt class="font-medium text-gray-500">{{'text.departure' | translate}}</dt>
                                <div class="mt-1 text-gray-900"><span class="truncate"
                                        *ngIf="route?.departure">{{route?.departure | timeformat}}</span><span
                                        *ngIf="!route?.departure">---</span></div>
                            </div>
                            <div class="p-4">
                                <dt class="font-medium text-gray-500">{{'text.total_jobs' | translate}}
                                </dt>
                                <div class="mt-1 text-gray-900"><span class="truncate"
                                        *ngIf="route?.total_jobs">{{route?.total_jobs}}
                                        {{'text.jobs' |
                                        translate}}</span><span *ngIf="!route?.total_jobs">---</span></div>
                            </div>
                            <div class="p-4">
                                <dt class="font-medium text-gray-500">{{'text.total_distance' |
                                    translate}}</dt>
                                <div class="mt-1 text-gray-900">
                                    <span class="truncate" *ngIf="route?.total_distance">
                                        {{utilityService.getDistance(route?.total_distance)}}
                                        {{(companyConfig?.general?.distance_metric === 'MILES'
                                        ? 'route.distance.metric.miles' : 'route.distance.metric.kilo_meters') |
                                        translate}}</span>
                                    <span *ngIf="!route?.total_distance">---</span>
                                </div>
                            </div>
                            <div class="p-4">
                                <dt class="font-medium text-gray-500">{{'text.route_type' | translate}}
                                </dt>
                                <div class="mt-1 text-gray-900"><span class="truncate"
                                        *ngIf="route?.route_type">{{route?.route_type | titlecase}}</span><span
                                        *ngIf="!route?.route_type">---</span></div>
                            </div>
                            <div class="p-4 col-span-2">
                                <dt class="font-medium text-gray-500">{{'text.assigned_to' | translate}}</dt>
                                <div class="mt-1 flex">
                                    <div class="flex items-center cursor-pointer">
                                        <div class="flex items-center justify-center w-10 h-10">
                                            <div class="flex">
                                                <ng-container *ngFor="let employee of route?.assigned_to;let i=index">
                                                    <ng-container>
                                                        <div *ngIf="!employee?.user?.profile_picture"
                                                            class="w-8 h-8 rounded-full text-card ring-2 ring-bg-card object-cover">
                                                            <div
                                                                class="flex items-center justify-center w-full h-full text-base uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 ng-star-inserted">
                                                                {{employee?.user?.first_name.slice(0,1)}} </div>
                                                        </div>
                                                        <img class="w-8 h-8 rounded-full text-card ring-2 ring-bg-card object-cover"
                                                            *ngIf="employee?.user?.profile_picture"
                                                            [src]="employee?.user?.profile_picture" alt="Avatar" />
                                                    </ng-container>
                                                </ng-container>
                                                <ng-container *ngIf="route?.assigned_to?.length === 0">
                                                    <span class="truncate -ml-4">---</span>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="p-4 col-span-2" *ngIf="route?.start_location?.street">
                                <dt class="font-medium text-gray-500">{{'text.start_location' | translate}}</dt>
                                <div class="mt-1 text-gray-900"><span class="truncate"><em
                                            class="ti ti-map-2 mr-2"></em>{{utilityService?.getFormattedAddress(route?.start_location)}}{{route?.start_location?.name
                                        ? ','+route?.start_location?.name : ''}}</span></div>
                            </div>
                            <div class="p-4 col-span-2" *ngIf="route?.end_location?.street">
                                <dt class="font-medium text-gray-500">{{'text.end_location' | translate}}</dt>
                                <div class="mt-1 text-gray-900"><span class="truncate"><em
                                            class="ti ti-map-2 mr-2"></em>{{utilityService?.getFormattedAddress(route?.end_location)}}{{route?.end_location?.name
                                        ? ','+route?.end_location?.name : ''}}</span></div>
                            </div>
                        </dl>
                    </div>
                </div>
            </li>
        </ul>
    </div>
    <div class="flex flex-col items-center justify-center primary-font assign-route-height" *ngIf="routes.length === 0">
        <div class="flex flex-col items-center justify-center">
            <img class="w-30 m-auto" src="assets/images/svgs/routes.svg" alt="No Route Found">
            <h4 class="font-medium mt-4 text-secondary text-base">{{'sidebar.data.route.not_found' |
                translate}}</h4>
        </div>
    </div>
</div>